import { Injectable, EventEmitter } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { EntityLicenseModel } from '../../model/entityLicenseModel';
import { SeverEmploymentRequestModel } from '../../model/severEmploymentRequestModel';
import { SeverEmploymentResponseModel } from '../../model/severEmploymentResponseModel';
import { CompleteFunctionResponseModel } from '../../model/completeFunctionResponseModel';

@Injectable()
export class SeverEmploymentService {

  private notifySeverEmploymentInformation: EventEmitter<EntityLicenseModel> = new EventEmitter<EntityLicenseModel>();
  private notifySelectedEmployer: EventEmitter<SeverEmploymentResponseModel> = new EventEmitter<SeverEmploymentResponseModel>();
  private notifySeverAgreement: EventEmitter<boolean> = new EventEmitter<boolean>();
  private notifyCompleteSeverEmployer: EventEmitter<CompleteFunctionResponseModel> = new EventEmitter<CompleteFunctionResponseModel>();

  constructor(private http: HttpClient) { }

  //Returns an EntityLicenseModel representing the user's current employer.
  getEmploymentInfo(sessionID: number) {
    const params = new HttpParams()
      .set('sessionID', sessionID.toString());
    return this.http.get<EntityLicenseModel>(environment.server_url + "/api/SeverEmployment", { params });
  }

  //Submit after the sever attestation and before the review pages. This will queue the sever which will complete during CompleteFunction
  submitSeverEmployment(severEmploymentRequestModel: SeverEmploymentRequestModel) {
    return this.http.post<SeverEmploymentResponseModel>(environment.server_url + "/api/SeverEmployment", severEmploymentRequestModel);
  }


  getNotifySeverEmploymentInformation() {
    return this.notifySeverEmploymentInformation;
  }

  getNotifySelectedEmployer() {
    return this.notifySelectedEmployer;
  }

  getNotifySeverAgreement() {
    return this.notifySeverAgreement;
  }

  getNotifyCompleteSeverEmployer() {
    return this.notifyCompleteSeverEmployer;
  }

  storeSeverSelectedEmploymentData(severEmploymentResponse: SeverEmploymentResponseModel) {
    localStorage.setItem('severSelectedEmployer', JSON.stringify(severEmploymentResponse));
  }

  getSeverSelectedEmploymentData(): SeverEmploymentResponseModel {
    if (localStorage.getItem('severSelectedEmployer') == null || localStorage.getItem('severSelectedEmployer') == undefined || isEmpty(JSON.parse(localStorage.getItem('severSelectedEmployer'))))
      return null;
    return JSON.parse(localStorage.getItem('severSelectedEmployer'));
  }

  clearSeverSelectedEmploymentData(): void {
    localStorage.removeItem('severSelectedEmployer');
  }

  storeSeverEmploymentInformationData(employmentInfo: EntityLicenseModel) {
    localStorage.setItem('severEmploymentInformation', JSON.stringify(employmentInfo));
  }

  getEmploymentInfoData(): EntityLicenseModel {
    if (localStorage.getItem('severEmploymentInformation') == null || localStorage.getItem('severEmploymentInformation') == undefined || isEmpty(JSON.parse(localStorage.getItem('severEmploymentInformation'))))
      return null;
    return JSON.parse(localStorage.getItem('severEmploymentInformation'));
   

  }

  clearEmploymentInfoData(): void {
    localStorage.removeItem('severEmploymentInformation');
  }

  storeAgreementData(agree: boolean) {
    if (agree != null || agree != undefined)
      localStorage.setItem('agree', agree.toString());
    localStorage.setItem('agree', null);

  }

  getAgreementData(): boolean {
    if (localStorage.getItem('agree') == null || localStorage.getItem('agree') == undefined || isEmpty(JSON.parse(localStorage.getItem('agree'))))
      return null;
    return JSON.parse(localStorage.getItem('agree'));
  }

  clearAgreementData(): void {
    localStorage.removeItem('agree');
  }
}
function isEmpty(obj) {
  for(var key in obj) {
      if(obj.hasOwnProperty(key))
          return false;
  }
  return true;
}


// WEBPACK FOOTER //
// ./src/app/broker/sever-employment/sever-employment.service.ts